import { gql } from "@apollo/client";

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser(
    $email: String!
    $firstName: String!
    $lastName: String!
    $password: String
    $registeringAs: UserKind!
    $ssoVerified: Boolean
  ) {
    createUser(
      email: $email
      firstName: $firstName
      lastName: $lastName
      password: $password
      registeringAs: $registeringAs
      ssoVerified: $ssoVerified
    ) {
      id
      email
    }
  }
`;
